import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const coachingFilesState = (state: RootState) => state.scene.dashboard.coaching.files;

export const getCoachingFiles = createSelector(coachingFilesState, ({ files }) => files);

export const isCoachingFilesLoading = createSelector(coachingFilesState, ({ loading }) => loading);

export const isCoachingFilesUploadLoading = createSelector(
  coachingFilesState,
  ({ uploadLoading }) => uploadLoading
);

export const getCoachingFilesDeleteLoadingIds = createSelector(
  coachingFilesState,
  ({ deleteLoadingIds }) => deleteLoadingIds
);

export const getCoachingFilesTagUpdateLoadingIds = createSelector(
  coachingFilesState,
  ({ tagUpdateLoadingIds }) => tagUpdateLoadingIds
);
